import React, { useState } from "react";
import { X, AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "wvh_disclaimer_dismissed";

export default function TopDisclaimer() {
  const { t } = useTranslation();

  // ─── Read dismissal synchronously before first paint to prevent CLS ───────
  // Using a lazy initializer means React sets initial state without a re-render.
  const [isVisible, setIsVisible] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) !== "1";
    } catch {
      return true; // Private browsing fallback
    }
  });

  if (!isVisible) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setIsVisible(false);
  };

  return (
    <div
      className="bg-yellow-50 border-b border-yellow-200 text-yellow-900 px-4 py-3 relative z-50"
      style={{ contain: "layout" }}
    >
      <div className="container mx-auto flex items-start gap-3 pr-8">
        <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-yellow-600" aria-hidden="true" />
        <div className="text-xs sm:text-sm font-medium leading-normal">
          <p>
            {t(
              "Disclaimer: Westlake Village Hospice Inc. is a licensed and Medicare-certified hospice care provider. We do not sell, prescribe, dispense, or ship prescription medications, and we do not operate an online pharmacy or telemedicine prescribing service. All hospice services are provided in person by licensed healthcare professionals. Any references to Medicare coverage, medication support, or medical coordination relate solely to patient care delivered under physician direction and do not constitute prescription drug sales or online medical services.",
            )}
          </p>
        </div>
        <button
          onClick={dismiss}
          className="absolute right-2 top-2 sm:relative sm:right-auto sm:top-auto sm:ml-auto p-1 hover:bg-yellow-100 rounded-full transition-colors text-yellow-700"
          aria-label={t("Close disclaimer")}
        >
          <X size={18} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
